import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';


export class NotificationsService {

    static async getNotifications(userId="", page=1, limit=10) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/notifications/getByUserId/${userId}?page=${page}&limit=${limit}`);
            const jsonData = await responseServer.data;
            return jsonData;

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }

    static async UpdateNotification(notificationId="", payload={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.put(`${variablesGlobales.urlServiceBackend}/api/v1/notifications/updateNotification/${notificationId}`, payload);
            const jsonData = await responseServer.data;
            return jsonData;

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }
}